import en from './en';

type Translation = {
  [key in keyof typeof en]: string;
};

type DiscussionTranslations = {
  [lang: string]: Translation;
};

export const discussionTranslations: DiscussionTranslations = {
  en,
};
